import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Check } from "lucide-react";
import { SEO } from "@/components/SEO";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-ivory border border-champagne/40 rounded-lg px-4 py-3 text-espresso focus:outline-none focus:ring-2 focus:ring-champagne focus:border-transparent";

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory px-6" data-testid="forgot-page">
      <SEO title="Forgot Password" description="Reset your password" />
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center font-serif text-3xl text-espresso">people, redefined.</Link>
        {done ? (
          <div className="bg-taupe rounded-2xl p-8 mt-8 text-center" data-testid="forgot-success">
            <Check className="mx-auto text-forest" size={36} />
            <h1 className="font-serif text-2xl text-espresso mt-4">Check your email.</h1>
            <p className="text-espresso/70 mt-3 text-sm">If that email is registered, a reset link has been sent. It expires in 1 hour.</p>
            <Link to="/login" className="inline-block mt-6 text-champagne hover:text-espresso transition-colors">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form" className="bg-taupe rounded-2xl p-8 mt-8 space-y-5">
            <h1 className="font-serif text-2xl text-espresso">Reset your password</h1>
            <p className="text-sm text-espresso/70">Enter your email and we'll send you a reset link.</p>
            <div>
              <label className="block text-sm font-medium text-espresso mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
            </div>
            {error && <p className="text-red-700 text-sm">{error}</p>}
            <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full inline-flex items-center justify-center gap-2 bg-espresso text-ivory rounded-full px-6 py-3 font-medium hover:bg-forest transition-colors disabled:opacity-60">
              {loading && <Loader2 className="animate-spin" size={18} />} Send Reset Link
            </button>
            <div className="text-center">
              <Link to="/login" className="text-sm text-espresso/60 hover:text-espresso transition-colors">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
